// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__8sAYo","header":"ReportDetails_header__22ldR","title":"ReportDetails_title__3CcNy","left":"ReportDetails_left__24Z6x"};